import React from 'react';
import PropTypes from 'prop-types';
import styles from '../icon.scss';

const BellIcon = ({ 'aria-hidden': ariaHidden, ...rest }) => (
  <svg
    {...rest}
    className={styles.icon}
    width={32}
    height={32}
    focusable="false"
    viewBox="0 0 32 32"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-icontype="Bell"
    data-testid="Portal-Bell-Icon"
    aria-hidden={ariaHidden}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26 11.501C26 11.5007 26 11.5003 26 11.5C26 6.25329 21.7467 2 16.5 2C11.2533 2 6.99998 6.25329 6.99998 11.5C6.99998 11.5023 6.99998 11.5045 6.99998 11.5068V15.7015C6.99998 16.2254 6.8628 16.7401 6.60209 17.1945L3.55533 22.5047C2.79033 23.838 3.75287 25.5 5.29008 25.5H27.4912C29.0039 25.5 29.9691 23.8855 29.2529 22.5531L26.3575 17.1662C26.1228 16.7296 26 16.2416 26 15.7459V11.501Z"
      fill="#C57B0D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.3884 31C18.5976 31 20.3884 29.2091 20.3884 27C20.3884 26.9997 20.3884 26.9993 20.3884 26.999H12.3884C12.3884 26.9993 12.3884 26.9997 12.3884 27C12.3884 29.2091 14.1793 31 16.3884 31Z"
      fill="#936116"
    />
  </svg>
);
BellIcon.displayName = 'BellIcon';
BellIcon.propTypes = {
  'aria-hidden': PropTypes.bool,
};
export default BellIcon;
